import React from 'react';
import './BWhatsapp.css'; // <-- 🩹 CIRUGÍA: Importamos el CSS modular

function BWhatsapp() {

  // Función para abrir WhatsApp en una nueva pestaña
  const openWhatsApp = () => {
    // (Asegúrate de reemplazar este número con tu número de WhatsApp Business)
    window.open('https://wa.me/525610480746', '_blank');
  };

  return (
    // 🩹 CIRUGÍA: Clase "whatsapp-float" renombrada a "b-whatsapp-float"
    <div className="b-whatsapp-float" onClick={openWhatsApp}>
      💬
    </div>
  );
}

export default BWhatsapp;
